const normalizeEmail = (value) => String(value || "").trim().toLowerCase();

const rawAllowed = process.env.REACT_APP_ALLOWED_EMAILS || "";
const allowedEmails = rawAllowed
  .split(",")
  .map(normalizeEmail)
  .filter(Boolean);

const isAccessRestricted = allowedEmails.length > 0;

const isAllowedEmail = (email) => {
  if (!isAccessRestricted) return true;
  return allowedEmails.includes(normalizeEmail(email));
};

export { allowedEmails, isAccessRestricted, isAllowedEmail };
